'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCheckedGroupContactsArray = exports.getGroupContactsSuggestionList = exports.getSuggestionList = exports.getGroup = exports.getFreeContacts = exports.getFilteredGroupContactsPage = exports.getGroupContacts = exports.getContacts = undefined;

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _keyBy2 = require('lodash/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _invertBy2 = require('lodash/invertBy');

var _invertBy3 = _interopRequireDefault(_invertBy2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _differenceBy2 = require('lodash/differenceBy');

var _differenceBy3 = _interopRequireDefault(_differenceBy2);

var _reselect = require('reselect');

var _utils = require('helpers/utils');

var _recipients = require('helpers/recipients');

var _contacts = require('helpers/contacts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Contacts and groups reselect */

var _getGroupId = function _getGroupId(state) {
  return state.contacts.groupContactsListActionData.groupId;
};
var _getGroups = function _getGroups(state) {
  return state.contacts.groupsListData;
};
var _getGroupContacts = function _getGroupContacts(state) {
  return state.contacts.groupContactsListData;
};
var _getContacts = function _getContacts(state) {
  return state.contacts.contactsListData.contacts;
};
var _getKw = function _getKw(state) {
  return state.contacts.kw;
};
var _getGroupContactsKw = function _getGroupContactsKw(state) {
  return state.contacts.groupContactsKw;
};
var _getSuggestionList = function _getSuggestionList(state) {
  return (0, _get3.default)(state.contacts, 'suggestionListData.contacts', []);
};
var _getGroupContactsPage = function _getGroupContactsPage(state) {
  return state.contacts.groupContactsPage;
};
var _getCheckedGroupContacts = function _getCheckedGroupContacts(state) {
  return state.contacts.checkedGroupContacts;
};

var getContacts = exports.getContacts = (0, _reselect.createSelector)([_getContacts], function (contacts) {
  return (0, _contacts.processContacts)(contacts);
});

var getGroupContacts = exports.getGroupContacts = (0, _reselect.createSelector)([_getGroupContacts], function (contacts) {
  return (0, _contacts.processContacts)(contacts);
});

var getFilteredGroupContactsPage = exports.getFilteredGroupContactsPage = (0, _reselect.createSelector)([_getGroupContacts, _getGroupContactsKw, _getGroupContactsPage], function (contacts, kw, page) {
  return (0, _contacts.getFilteredContactsPage)({ contacts: contacts, kw: kw, page: page });
});

var groupContactsByIds = (0, _reselect.createSelector)([getGroupContacts, getContacts], function (groupContacts, allContacts) {
  var freeContacts = (0, _keyBy3.default)(allContacts, 'id');

  groupContacts.map(function (groupContact) {
    if (freeContacts[groupContact.id]) {
      delete freeContacts[groupContact.id];
    }
  });

  return { groupContacts: groupContacts, freeContacts: (0, _map3.default)(freeContacts) };
});

var getFreeContacts = exports.getFreeContacts = (0, _reselect.createSelector)([groupContactsByIds, _getKw], function (contacts, kw) {
  return (0, _utils.filterObjectsByKw)(contacts.freeContacts, ['fullName', 'userEmail'], kw);
});

var getGroup = exports.getGroup = (0, _reselect.createSelector)([_getGroupId, _getGroups], function (groupId, groups) {
  return (0, _find3.default)(groups, { id: groupId }) || {};
});

var getSuggestionList = exports.getSuggestionList = (0, _reselect.createSelector)([_getSuggestionList], function (contacts) {
  return (0, _recipients.processRecipients)(contacts);
});

var getGroupContactsSuggestionList = exports.getGroupContactsSuggestionList = (0, _reselect.createSelector)([_getSuggestionList, _getGroupContacts], function (contacts, groupContacts) {
  var filteredContacts = (0, _differenceBy3.default)(contacts, groupContacts, 'id');
  return (0, _recipients.processRecipients)(filteredContacts);
});

var getCheckedGroupContactsArray = exports.getCheckedGroupContactsArray = (0, _reselect.createSelector)([_getCheckedGroupContacts], function (items) {
  return ((0, _invertBy3.default)(items).true || []).map(Number);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/contacts.js
// module id = 185
// module chunks = 1